import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { assetCatalogPath, assetCatalogBasePath } from '@/components/assetCatalog/assetCatalogNav'
import { useClientContextStore } from '@/store/clientContext'

/**
 * Paths for the client-scoped Asset Catalog workspace.
 * Prefer :clientId from the URL; fall back to active client in the store.
 */
export function useAssetCatalogPaths() {
  const { clientId: clientIdParam } = useParams<{ clientId?: string }>()
  const activeClient = useClientContextStore((s) => s.activeClient)

  const clientId = clientIdParam ?? (activeClient?.id != null ? String(activeClient.id) : null)

  return useMemo(() => {
    if (!clientId) {
      return {
        clientId: null as string | null,
        base: '/organization/clients',
        overview: '/organization/clients',
        path: (_segment: string) => '/organization/clients',
      }
    }

    return {
      clientId,
      base: assetCatalogBasePath(clientId),
      overview: assetCatalogPath(clientId, 'overview'),
      path: (segment: string) => assetCatalogPath(clientId, segment),
    }
  }, [clientId])
}
